import { useFormContext, useWatch } from 'react-hook-form';
import { Box } from '@mui/material';
import { CustomButton } from '@/components/global/buttons/CustomButton.jsx';
import { BrandConfiguration } from '@/components/brand/forms/BrandConfiguration.jsx';

export const BrandConfigurationSection = () => {
    const { setValue } = useFormContext();
    const overrideConfiguration = useWatch({ name: 'overrideConfiguration' });

    const showConfiguration = () => {
        setValue('overrideConfiguration', true, { shouldDirty: true });
        setValue('forwarderType', 'Default', { shouldDirty: true });
        setValue('operators', [], { shouldDirty: true });
        setValue('depositWithdrawalMethods', ['cash'], { shouldDirty: true });
    };

    if (!overrideConfiguration) {
        return (
            <Box sx={{ mt: '40px', alignSelf: 'end' }}>
                <CustomButton
                    type='button'
                    color='primary'
                    variant='contained'
                    label='resources.brand.labels.overrideConfiguration'
                    onClick={showConfiguration}
                />
            </Box>
        );
    }

    return <BrandConfiguration />;
};

BrandConfigurationSection.propTypes = {};
